import React, {Component, Fragment} from "react";
import {getMessage} from "./util";
import {Button} from "reactstrap";

const version = require('../package.json');

class Footer extends Component {


    render() {
        const contact = (this.props.election && this.props.election.configuration.contact)?this.props.election.configuration.contact:({

        email: getMessage('support_phone',this.props.messages),
        phone: getMessage('support_mail',this.props.messages)

    });

        return (
            <Fragment>
                <div className="row EvColor text-white p-1 justify-content-center">
                    <div className="col-12 mb-2  text-center">

                        {getMessage('support_title',this.props.messages)}: {contact.email}
                        <br/>
                        <Button className="btn-wsp btn-light" target="_blank" href="https://api.whatsapp.com/send/?phone=56984490669"
                                >
                            <span className="iconVote"></span>
                            <span>Soporte</span>
                        </Button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 text-right">
                        <small>{version.version}</small>
                    </div>
                </div>
            </Fragment>
        );
    }
}


export default Footer;
